(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');

ga('create', 'UA-31900423-1', 'auto');
ga('require', 'displayfeatures');
ga('require', 'linkid', 'linkid.js');
ga('send', 'pageview');

var track = function(vendor, url) {
   ga('send', 'event', 'outbound', vendor, url);
}
var trackDeckOutbound = function(vendor, slug) {
   ga('send', 'event', 'deck_outbound', vendor, slug);
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    if (!e.target) return;
    var deckTrackEl = e.target.closest('[data-track-outbound-deck]');
    if (deckTrackEl) {
      var vendor = deckTrackEl.dataset.vendor;
      var slug = deckTrackEl.dataset.trackOutboundDeck;
      trackDeckOutbound(vendor, slug);
    }
    var trackEl = e.target.closest('[data-track]');
    if (trackEl) {
      var category = trackEl.dataset.category;
      var action = trackEl.dataset.action;
      var label = trackEl.dataset.label;
      var value = trackEl.dataset.value;
      ga('send', 'event', category, action, label, value);
    }
  });
});
